import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";

/**
 * 商品订单
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class GoodsOrderService extends ServiceBase
{
    /**
     * 获取订单列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getGoodsOrderPage(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getGoodsOrderPage({
            data: data
        });

        return response;
    }

    /**
     * 获取订单详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getGoodsOrderdetail(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.getGoodsOrderdetail({
            urlPath: {
                id
            }
        });

        return response;
    }

    /**
     * 修改收货人地址
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async changeOrderReceiptInfo(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.changeOrderReceiptInfo({
            data:data
        });

        return response;
    }

    /**
     * 订单配送
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async orderDelivery(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.orderDelivery({
            data:data
        });

        return response;
    }

    /**
     * 订单备注
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async addOrderRemark(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.addOrderRemark({
            data:data
        });

        return response;
    }

    /**
     * 修改订单费用
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async changeOrderCost(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.changeOrderCost({
            data:data
        });

        return response;
    }

    /**
     * 获取订单物流
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getOrderExpress(id: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getOrderExpress({
            urlPath: {
                id
            }
        });

        return response;
    }

}